module.exports = __webpack_public_path__ + "img/02_no.a761067a.svg";